import { graphql } from '@apollo/client/react/hoc';
import { flowRight as compose } from 'lodash';

import HideFundRecommendationMutation from 'buyside/graphql/mutations/HideFundRecommendation';
import AllocatorProfileCardRecommendation from 'buyside/components/presentation/AllocatorProfileCard/allocatorProfileCardRecommendation';

const withDeleteFund = graphql(HideFundRecommendationMutation, {
  props: ({ mutate }) => ({
    handleHideFundRecommendation: ({ fundRecommendationId }) => {
      return mutate({
        variables: { fundRecommendationId },
        update: cache => {
          cache.modify({
            fields: {
              allocatorRecommendations: (existing = {}, { readField }) => {
                const edges = readField('edges', existing) || [];
                const filteredEdges = edges.filter(edge => {
                  const node = readField('node', edge);
                  return readField('id', node) !== fundRecommendationId;
                });

                return {
                  ...existing,
                  edges: filteredEdges
                };
              }
            }
          });
        }
      });
    }
  })
});

const AllocatorProfileCardRecommendationContainer = compose(withDeleteFund)(
  AllocatorProfileCardRecommendation
);

export default AllocatorProfileCardRecommendationContainer;
